exports = module.exports = require("../../../../apps/experimentation-ui/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ane-DetailsList .ane-DetailsList-Header_right .ms-DetailsHeader-cellTitle {\n  justify-content: flex-end;\n}\n.ane-DetailsList .ms-DetailsHeader-cellName {\n  font-weight: bold;\n}\n.ane-DetailsList.ane-DetailsList-alternate .ms-DetailsHeader-cell {\n  background-color: #015aa0;\n  color: #ffffff;\n}", ""]);

